import { /*React, */ Component } from 'react';
import PropTypes from 'prop-types';
import StoreController from '@projeccions-pdc/frontend-storage';
import { isDeviceOnline } from '../../helpers';
import ConfigurationService from '../../apiclients/ConfigurationService';

class CachedImage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.refreshOnline();
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = [].slice.call(new Uint8Array(buffer));

        bytes.forEach((b) => (binary += String.fromCharCode(b)));

        return window.btoa(binary);
    }

    refreshOnline = async () => {
        let isOnline = await isDeviceOnline();

        let platformId = this.props.platformId ? this.props.platformId : 'default';
        let storeController = new StoreController(platformId, '');

        let logo;
        if (this.props.noCache === true) {
            if (this._isMounted) this.setState({ isOnline, logo: ConfigurationService.getStaticFileURL(platformId, this.props.fileName) });
        } else {
            if (isOnline === true) {
                try {
                    let response = await ConfigurationService.getPlatformStaticFile(platformId, this.props.fileName);
                    let buffer = await response.arrayBuffer();
                    let base64Flag = 'data:image/png;base64,';
                    let imageStr = this.arrayBufferToBase64(buffer);

                    logo = base64Flag + imageStr;
                    storeController.set(this.props.imageKey, logo);
                } catch (err) {
                    console.log(err.message);
                }
            } else {
                let aux = storeController.get(this.props.imageKey);
                if (aux !== undefined) {
                    logo = aux;
                } else {
                    logo = ConfigurationService.getStaticFileURL(platformId, this.props.fileName);
                }
            }
            if (this._isMounted) this.setState({ isOnline, logo });
        }
    };

    render() {
        let { logo } = this.state;

        // if (logo === undefined) {
        //     return (
        //         <div />
        //     );
        // } else {
        return this.props.renderElement(logo);
        // }
    }
}

CachedImage.propTypes = {
    renderElement: PropTypes.func.isRequired,
    imageKey: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
    platformId: PropTypes.string.isRequired,
};

export default CachedImage;
